import * as stylex from "@stylexjs/stylex";
import { motion } from "framer-motion";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import * as M from "../../materials";
import { breakpoints, colors, layoutAreas } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
import { foldRAliasTheme_, themeAliases } from "../../routes";
const styles = {
    listItem: {
        k1xSpc: "x1lliihq",
        kaIpWk: "x1nj7uno",
        kzqmXN: "x3hqpx7 xwqm7e3",
        keoZOQ: "xqui205 xuc0mqo",
        $$css: true
    }
};
export const getLabel = foldRAliasTheme_({
    access: ()=><FormattedMessage id="Access" defaultMessage="Access"/>,
    equity: ()=><FormattedMessage id="Equity" defaultMessage="Equity"/>,
    learning: ()=><FormattedMessage id="Learning" defaultMessage="Learning"/>,
    quality: ()=><FormattedMessage id="Quality" defaultMessage="Quality"/>,
    finance: ()=><FormattedMessage id="Finance" defaultMessage="Finance"/>
});
const parentVariants = (color)=>({
        default: {
            color: "inherit",
            y: 0,
            zIndex: 0
        },
        hover: {
            color,
            y: 0,
            zIndex: 1
        }
    });
const childVariants = ()=>({
        default: {
            y: 0,
            scale: 1
        },
        hover: {
            y: 0,
            scale: 1.05
        }
    });
const illuVariants = {
    default: {
        y: 0,
        scale: 1
    },
    hover: {
        y: -5.5,
        scale: 1.1
    }
};
const textVariants = {
    default: {
        y: 0,
        scale: 1
    },
    hover: {
        y: 2,
        scale: 1
    }
};
function setHomeGridBackground(color) {
    if (typeof document !== "undefined") {
        document.documentElement.style.setProperty("--homegrid-background", color);
    }
}
export const ThemeLinks = (_props)=>{
    return <div className="xki0xp4">
      <ul className="x78zum5 xl56j7k x1s3upz x1717udv xwvmffy x1jkqq1h xqld4bp x8xla69 xcwtdwv x1a02dak x1a60tsp">
        {themeAliases.map((alias)=>{
        const theme = M.themes[alias];
        return <li {...stylex.props(typography.body2, styles.listItem)} key={alias}>
              <Link href={`/articles/${alias}`}>
                {" "}
                <motion.div className="xo1l8bm x1j61x8r x1lliihq x2b8uid x196nufh xqui205 xwo1ent" variants={parentVariants(theme.textColor)} whileHover="hover" onMouseEnter={()=>{
            setHomeGridBackground(M.utils.lighten(theme.background.light, 0.6));
        }} onMouseLeave={()=>{
            setHomeGridBackground("white");
        }}>
                  {theme.kind === "article" && <motion.div className="x1n2onr6 x2pejg6 xekxv85 x1ch3e0b x12oqio5" initial="default" variants={childVariants()}>
                      <motion.img src={theme.illustration} role="presentation" initial="default" variants={illuVariants} className="x10l6tqk xu5yr9u xtzbgxg xwv353n"/>
                    </motion.div>}
                  <motion.div variants={textVariants}>{getLabel(alias)}</motion.div>
                </motion.div>
              </Link>
            </li>;
    })}
      </ul>
    </div>;
};
